"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.polygonToOLPolygon = void 0;
const Polygon_1 = __importDefault(require("ol/geom/Polygon"));
const proj_1 = require("ol/proj");
function polygonToOLPolygon(polygon) {
    if (polygon.type === 'GeometryCollection')
        return null;
    const coordinates = polygon === null || polygon === void 0 ? void 0 : polygon.coordinates;
    if (!coordinates) {
        return null;
    }
    try {
        return new Polygon_1.default(coordinates.map((x) => x.map(y => proj_1.fromLonLat(y))));
    }
    catch (e) {
        console.error('Could not convert polygon to openlayers polygon.');
        console.error(e);
        return null;
    }
}
exports.polygonToOLPolygon = polygonToOLPolygon;
//# sourceMappingURL=polygonToOLPolygon.js.map